import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withIcon = true,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold text-lg px-8 py-4 rounded-lg transition-all transform active:scale-95 shadow-lg';
  const variants = {
    primary: 'bg-accent-yellow text-black hover:bg-yellow-400 hover:shadow-glow-yellow border-2 border-transparent',
    secondary: 'bg-transparent text-white border-2 border-white/20 hover:border-accent-blue hover:text-accent-blue hover:bg-accent-blue/10'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-187">
      {children}
      {withIcon && <ArrowRight className="ml-2 w-5 h-5" data-id="element-188" />}
    </motion.button>;
}